import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BACKEND_URL } from "@/lib/api";

const G = "#FFB800";

/* Fix known bad hrefs from CMS */
const HREF_FIXES = {
  "/orders": "/track",
};

const SOCIAL_ICONS = {
  instagram: (
    <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
  ),
  facebook: (
    <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
  ),
  twitter: (
    <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
  ),
  youtube: (
    <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
  ),
  whatsapp: (
    <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
  ),
  linkedin: (
    <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
  ),
};

export default function CmsFooter() {
  const [footer, setFooter] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/content/homepage`)
      .then(r => r.json())
      .then(d => setFooter(d.sections?.site_footer))
      .catch(() => {});
  }, []);

  const columns = footer?.columns || [];
  const social = footer?.social_links || [];
  const legal = footer?.legal_text || "2026 NirvanaComfort. All rights reserved.";

  const gridClass = columns.length <= 2 ? "grid-cols-2 md:grid-cols-3"
    : columns.length === 3 ? "grid-cols-2 md:grid-cols-4"
    : "grid-cols-2 md:grid-cols-5";

  // Preload page chunk on hover for instant navigation
  const preloadRoute = (href) => {
    const routeMap = {
      "/blog": () => import("@/modules/storefront/pages/BlogPage"),
      "/faq": () => import("@/modules/storefront/pages/FAQPage"),
      "/about": () => import("@/modules/storefront/pages/AboutPage"),
      "/contact": () => import("@/modules/storefront/pages/ContactPage"),
      "/browse": () => import("@/modules/storefront/pages/BrowsePage"),
      "/sleep-quiz": () => import("@/modules/storefront/pages/SleepQuiz"),
    };
    const loader = routeMap[href];
    if (loader) loader();
  };

  const handleLinkClick = (e, href, label) => {
    e.preventDefault();
    e.stopPropagation();
    let fixedHref = HREF_FIXES[href] || href;
    // Label-specific override: Blog must always go to /blog
    if (label === "Blog") fixedHref = "/blog";
    if (!fixedHref || fixedHref === "#") return;
    navigate(fixedHref);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="pb-28 md:pb-0 bg-gray-900 border-t border-gray-800" style={{ position: "relative", zIndex: 30 }} data-testid="cms-footer">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 py-10 md:py-16">
        <div className={`grid ${gridClass} gap-6 sm:gap-8`}>
          <div className="col-span-2 md:col-span-1">
            <h3 className="text-lg sm:text-xl font-bold tracking-tight mb-3" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
              <span style={{ color: G }}>Nirvana</span><span className="text-white">Comfort</span>
            </h3>
            <p className="text-sm leading-relaxed mb-2 text-gray-400" style={{ maxWidth: "220px", lineHeight: 1.8 }}>
              Comfort products engineered for the way India actually lives — from desk to bed.
            </p>
            <p className="text-xs leading-relaxed mb-4 text-gray-500" style={{ maxWidth: "220px", lineHeight: 1.7 }}>
              T510 F15A, Ground Floor, Patel Nagar West, Central Delhi - 110008
            </p>
            <a href="https://wa.me/919811742827" target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-green-400 transition-colors mb-4"
              data-testid="footer-whatsapp-link">
              <svg viewBox="0 0 24 24" className="w-4.5 h-4.5" fill="currentColor" style={{ width: 18, height: 18 }}>
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              +91 98117 42827
            </a>
            {social.length > 0 && (
              <div className="flex gap-3">
                {social.map((s, i) => {
                  const platform = (s.platform || '').toLowerCase();
                  const icon = SOCIAL_ICONS[platform];
                  return (
                    <a key={i} href={s.url} target="_blank" rel="noopener noreferrer"
                      data-testid={`social-${platform}`}
                      className="w-9 h-9 rounded-full flex items-center justify-center transition-all hover:scale-110 bg-gray-800 text-gray-400 hover:text-white">
                      {icon || <span className="text-xs font-bold">{s.platform?.[0]?.toUpperCase()}</span>}
                    </a>
                  );
                })}
              </div>
            )}
          </div>
          {columns.map((col, i) => (
            <div key={i}>
              <h4 className="text-[11px] font-bold tracking-widest uppercase mb-3 sm:mb-4 text-white">{col.title}</h4>
              <div className="flex flex-col gap-0.5">
                {(col.links || []).filter(link => link.href && link.href !== "#").map((link, j) => (
                  <a key={j}
                    href={HREF_FIXES[link.href] || link.href}
                    onClick={(e) => handleLinkClick(e, link.href, link.label)}
                    onMouseEnter={() => preloadRoute(HREF_FIXES[link.href] || link.href)}
                    className="inline-block text-sm py-2.5 cursor-pointer origin-left text-gray-400 hover:text-white transition-colors"
                    style={{
                      touchAction: "manipulation",
                      WebkitTapHighlightColor: "transparent",
                      pointerEvents: "auto",
                      minHeight: "44px",
                      display: "flex",
                      alignItems: "center",
                    }}
                    data-testid={`footer-link-${col.title.toLowerCase().replace(/\s+/g, '-')}-${j}`}>
                    {link.label}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="mt-8 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4 border-t border-gray-800">
          <p className="text-xs text-gray-500">&copy; {legal}</p>
          <div className="flex gap-3">
            {["UPI", "Cards", "COD", "EMI"].map(p => (
              <span key={p} className="text-[10px] font-semibold rounded-md px-2 py-1 text-gray-500 border border-gray-700">{p}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
